import React, { useEffect, useRef, useState } from 'react';
import { handleTrack } from '../../../../utils/tracker';
import { MarktechModal } from '../../../Atoms/Modal';
import { WebinarLeadForm } from '../../Common/WebinarLeadForm';
import { useOnClickOutside } from '../../../hooks';
import { Video } from '../../../Ui';
import { FORM_DATA } from '../../Common/WebinarLeadForm/Utils/types';
import { SUCCEESS_MODAL_PROPS } from '../../../Ui/SuccessModal';
import { DEFAULT_THUMBNAIL, EVENT_TYPE } from '../../Utils/constants';
import { LOCAL_STORAGE } from '../../Common/WebinarLeadForm/FormData/formConstants';
import { IWEBINAR_DATA } from '../../Utils/types';

interface WEBINAR_VIDEO_FORM_PROPS {
  webinarDetails: IWEBINAR_DATA;
  leadForm: LEAD_FORM_PROPS;
}

type LEAD_FORM_PROPS = {
  eventType: EVENT_TYPE;
  formTitle: string;
  initailFormData: Record<string, FORM_DATA>;
  buttonText: string;
  onClick?: () => void;
  successData: SUCCEESS_MODAL_PROPS;
};

export const WebinarVideoForm = ({
  webinarDetails,
  leadForm,
}: WEBINAR_VIDEO_FORM_PROPS): JSX.Element => {
  const modalRef = useRef(null);
  const [isFormPopupVisible, setIsFormPopupVisible] = useState(false);
  const [hasAccess, setAccess] = useState(false);
  const [successfulFormSubmission, setSuccessfulFormSubmission] =
    useState(false);
  const imageLink =
    webinarDetails.image_link && webinarDetails.image_link !== 'NA'
      ? webinarDetails.image_link
      : DEFAULT_THUMBNAIL;

  useOnClickOutside(modalRef, () => {
    setIsFormPopupVisible(false);
  });

  useEffect(() => {
    const isLeadSubmitted = localStorage.getItem(
      LOCAL_STORAGE.IS_LEAD_SUBMITTED
    );
    isLeadSubmitted === 'true' && !isFormPopupVisible
      ? setAccess(true)
      : setAccess(false);
  }, [successfulFormSubmission, isFormPopupVisible]);

  const handleVideoFormToggle = () => {
    if (!hasAccess) {
      setIsFormPopupVisible(true);
      handleTrack({ label: `open_lead_form_${leadForm.buttonText}` });
    }
  };

  const setSuccess = () => setSuccessfulFormSubmission(true);
  const hideModal = () => setIsFormPopupVisible(false);

  return (
    <div>
      <div
        id="videoHolder"
        onClick={handleVideoFormToggle}
        data-testid="video-form"
      >
        {webinarDetails.video_link ? (
          <Video
            videoId="actualVideo"
            webmSrc={webinarDetails.video_link}
            mp4Src={webinarDetails.video_link}
            poster={imageLink}
            hasAccessToPlay={hasAccess && !isFormPopupVisible}
            showButton={true}
            platform={webinarDetails.platform}
          />
        ) : null}
      </div>

      <MarktechModal
        open={isFormPopupVisible}
        onClose={hideModal}
        classNames={{
          modal: 'w-fit mobile-search-box rounded-2xl sm:w-11/12',
        }}
        center
      >
        <WebinarLeadForm
          webinarDetails={webinarDetails}
          eventType={leadForm.eventType}
          formTitle={leadForm.formTitle}
          initailFormData={leadForm.initailFormData}
          buttonText={leadForm.buttonText}
          modalRef={modalRef}
          onSuccess={setSuccess}
          successData={{
            icon: leadForm.successData?.icon,
            title: leadForm.successData.title,
            desc: leadForm.successData.desc,
            buttonText: leadForm.successData.buttonText,
            buttonFn: hideModal,
          }}
        />
      </MarktechModal>
    </div>
  );
};
